<template>
  <div class="view-active-campaign">
    <h4 class="text-semibold mb-5">RD Station</h4>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-4 d-flex flex-column align-items-center gap-4">
            <h2 class="text-semibold">Ainda não há nada aqui</h2>
            <img src="@/assets/images/no-content.svg" />
            <h3>Talvez você precise</h3>
            <snow-button
              text="Integrar sua conta"
              icon="ph ph-plus"
              @click="modal = true"
            />
            <h5 class="text-dark-40">
              Integre sua conta de e-mail marketing para garantir um perfeito
              fluxo de disparos para seus clientes
            </h5>
          </div>
        </div>
      </div>
      <div v-else>
        <snow-data-table :data="integrationList" :columns="columns" />
      </div>
      <div class="d-flex justify-content-end">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <RDStationModal v-model="modal" @refresh="refresh" />
  </div>
</template>
<script>
import RDStationModal from "@/components/tools/modals/RDStation";
import { mapState } from "vuex";

export default {
  components: {
    RDStationModal
  },
  data() {
    return {
      loading: false,
      modal: false,
      product_id: null,
      page: 1,
      search: "",
      actions: []
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", "rd-station");
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"]),
    columns() {
      return [
        {
          name: "Client ID",
          field: "client_id"
        },
        {
          name: "Client secret",
          field: "client_secret"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v == "active" ? "Ativo" : "Inativo"),
          color: v => (v == "active" ? "green" : "negative"),
          type: "tag"
        },
        {
          name: "Status da integração",
          field: "integration_status",
          transform: v => (v == "connected" ? "Conectada" : "Desconectada"),
          color: v => (v == "connected" ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    getActions(item) {
      const actions = [...this.actions];
      actions.push({
        class: item.status == "active" ? "text-danger" : "text-success",
        label: item.status == "active" ? "Desativar" : "Ativar",
        click: () => this.changeStatus(item)
      });
      if (item.integration_status == "disconnected")
        actions.push({
          class: "text-success",
          label: "Autorizar aplicativo",
          click: () => this.authorize(item)
        });
      actions.push({
        label: "Excluir",
        class: "text-danger",
        variant: "danger",
        dialog: {
          icon: "icon-trash",
          text:
            "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação.",
          buttonText: "Sim, excluir",
          action: () => this.submitDelete(item),
          secondaryButtonText: "Não, cancelar"
        }
      });
      return actions;
    },
    authorize(item) {
      window.open(item.url);
    },
    searching(search) {
      this.search = search;
      this.dispatch();
    },
    dispatch() {
      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteProvider", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a conta integrada");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      this.$store
        .dispatch("integration/putIntegration", {
          id: item.id,
          status: item.status == "active" ? "inactive" : "active"
        })
        .then(this.refresh)
        .catch(() => this.$message.error("Não foi possível alterar o status"));
    },
    refresh() {
      this.dispatch();
    }
  }
};
</script>
